import React, { useState } from "react";

const brands = [
  { brand: "Maruti Suzuki" },
  { brand: "Hyundai" },
  { brand: "Tata Motors" },
  { brand: "Mahindra" },
  { brand: "Toyota" },
  { brand: "Kia" },
  { brand: "Honda" },
  { brand: "Chavrolet" },
  { brand: "Volkswagen" },
  { brand: "Skoda" },
  { brand: "Renault" },
  { brand: "Nissan" },
  { brand: "Ford" },
  { brand: "Mercedes-Benz" },
  { brand: "BMW" },
  { brand: "Audi" },
  { brand: "Volvo" },
  { brand: "Jaguar" },
  { brand: "Others" },
];

const BuyersForm = ({ onSubmit, onClose }) => {
  const [formdata, setFormdata] = useState({
    name: "",
    mobileNumber: "",
    email: "",
    price: "",
    brand: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    mobileNumber: "",
    email: "",
    price: "",
    brand: "",
  });

  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (formdata.name.trim() === "") {
      tempErrors.name = "Name is required";
      isValid = false;
    }

    if (!/^\d{10}$/.test(formdata.mobileNumber)) {
      tempErrors.mobileNumber = "Please enter a valid 10-digit mobile number";
      isValid = false;
    }

    if (!/\S+@\S+\.\S+/.test(formdata.email)) {
      tempErrors.email = "Please enter a valid email address";
      isValid = false;
    }

    if (
      formdata.price.trim() === "" ||
      isNaN(formdata.price) ||
      parseFloat(formdata.price) <= 0
    ) {
      tempErrors.price = "Please enter a valid price";
      isValid = false;
    }

    if (formdata.brand === "") {
      tempErrors.brand = "Please select a brand";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "mobileNumber") {
      if (/^\d{0,10}$/.test(value)) {
        newValue = value;
      } else {
        return;
      }
    }

    setFormdata({
      ...formdata,
      [name]: newValue,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onSubmit(formdata);
    }
  };

  return (
    <>
      <button
        onClick={onClose}
        className="absolute top-[-30px] right-2 mt-9 bg-red-500 text-white px-2 py-1 rounded"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-5 h-5"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L12 10.586l6.293-6.293a1 1 0 111.414 1.414L13.414 12l6.293 6.293a1 1 0 01-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 01-1.414-1.414L10.586 12 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      <div
        style={{
          fontFamily: "Ballega",
          maxHeight: "90vh",
          overflowY: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="overflow-y-auto p-4 py-9 h-[30rem] md:h-[40rem]"
      >
        <div className="bg-sky-500 p-4 md:px-6 md:py-10 flex flex-col gap-6 rounded-xl">
          <h4 className="md:text-3xl text-white text-center">
            Enter your Requirement
          </h4>
          <form
            onSubmit={handleSubmit}
            style={{
              fontFamily: "Barlow Condensed",
            }}
          >
            <input
              type="text"
              name="name"
              className="arial text-lg font-bold placeholder-black border border-2 border-gray-300 w-full rounded-md p-2 my-3 bg-sky-500 outline-none"
              placeholder="Enter your name"
              value={formdata.name}
              onChange={handleInputChange}
              required
            />
            {errors.name && (
              <p className="text-red-500 text-sm">{errors.name}</p>
            )}

            <input
              type="text"
              name="mobileNumber"
              className="arial text-lg font-bold placeholder-black border border-2 border-gray-300 w-full rounded-md p-2 my-3 bg-sky-500 outline-none"
              placeholder="Enter Phone Number"
              value={formdata.mobileNumber}
              maxLength="10"
              onChange={handleInputChange}
              required
            />
            {errors.mobileNumber && (
              <p className="text-red-500 text-sm">{errors.mobileNumber}</p>
            )}

            <input
              type="email"
              name="email"
              className="arial text-lg font-bold placeholder-black border border-2 border-gray-300 w-full rounded-md p-2 my-3 bg-sky-500 outline-none"
              placeholder="Enter e-mail"
              value={formdata.email}
              onChange={handleInputChange}
            />
            {errors.email && (
              <p className="text-red-500 text-sm">{errors.email}</p>
            )}

            <input
              type="number"
              name="price"
              className="arial text-lg font-bold placeholder-black border border-2 border-gray-300 w-full rounded-md p-2 my-3 bg-sky-500 outline-none"
              placeholder="Enter Price Range"
              value={formdata.price}
              onChange={handleInputChange}
              required
            />
            {errors.price && (
              <p className="text-red-500 text-sm">{errors.price}</p>
            )}

            <select
              name="brand"
              className="arial text-lg font-bold placeholder-black border border-2 border-gray-300 w-full rounded-md p-2 my-3 bg-sky-500 outline-none"
              value={formdata.brand}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Brand</option>
              {brands.map((brandObj, index) => (
                <option key={index} value={brandObj.brand}>
                  {brandObj.brand}
                </option>
              ))}
            </select>
            {errors.brand && (
              <p className="text-red-500 text-sm">{errors.brand}</p>
            )}

            <div className="flex justify-center">
              <button
                type="submit"
                className="px-4 py-2 mt-4 text-white bg-sky-600 hover:bg-sky-500 hover:text-black hover:font-bold border border-2 border-gray-300"
              >
                Submit Your Details
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default BuyersForm;
